<template>
    <div class="d-flex align-items-start justify-content-center">
        <canvas id="timerCanvas" class="d-flex mt-2"></canvas>
        <span id="timerLabel" class="margin-clock font-s font-weight-bold text-success position-absolute">
            <span v-if="araw != 0">{{araw}}D</span> 
            <span v-if="oras != 0">{{oras}}H</span> 
            <span v-if="minuto != 0">{{minuto}}m</span>
            {{segundo}}s
        </span>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    props:{
        dateTime: {
            type: Number,
        },
        // seconds: {
        //     type: Number,
        //     default: 0
        // }
    },
    data() {
        return {
            // currentMinutes: this.minutes,
            // currentSeconds: this.seconds,
            countDownDate : null,
            originalDistance : 0,
            canvas: null,
            radialPercentage: null,
            araw: 0,
            oras: 0,
            minuto: 0,
            segundo: 0,
        }
    },
    mounted() {
        this.canvas = document.getElementById('timerCanvas');
        this.startTimer();
    },
    methods:  {
        startTimer() {
            let vm = this;
            var countDownDate = new Date(moment(this.dateTime).format("MMM DD, YYYY kk:mm:ss")).getTime();
            // var countDownDate2 = new Date("Sep 20, 2022 12:00:00").getTime();
            // alert(countDownDate2);
            let interval = 1000;
            vm.originalDistance = this.dateTime - Date.now();
            var x = setInterval(function() {
                // Get today's date and time
                var now = new Date().getTime();
                // Find the distance between now and the count down date
                var distance = countDownDate - now;
                if(distance <= 0) {
                    vm.araw = 0;
                    vm.oras = 0;
                    vm.minuto = 0;
                    vm.segundo = 0;
                    vm.$emit('end', vm.startTimer);
                    clearInterval(x);
                }else {
                    // Time calculations for days, hours, minutes and seconds
                    vm.radialPercentage = (360/100) * (100 - ((distance / vm.originalDistance) * 100));
                    vm.araw = Math.floor(distance / (1000 * 60 * 60 * 24));
                    vm.oras = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    vm.minuto = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    vm.segundo = Math.floor((distance % (1000 * 60)) / 1000);
                }
            }, interval);

            this.arcMove();
        },
        formatTimeUnits(val) {
            return ("0" + val).slice(-2); 
        },
        arcMove(){
            let vm = this;
            let context = vm.canvas.getContext('2d');
            
            let posX = vm.canvas.width / 2,
                posY = vm.canvas.height / 2,
                interval = 1000,
                oneProcent = 360 / 100,
                result = oneProcent * 64;
            
            context.lineCap = 'round';

            let degrees = vm.radialPercentage;
            let arcInterval = setInterval (function() {
            context.clearRect( 0, 0, vm.canvas.width, vm.canvas.height );

            context.beginPath();
            context.arc( posX, posY, 70, (Math.PI/180) * 270, (Math.PI/180) * (270 + 360) );
            context.strokeStyle = '#49B672';
            context.lineWidth = '5';
            context.stroke();

            context.beginPath();
            context.strokeStyle = '#D9D9D9';
            context.lineWidth = '5';
            context.arc( posX, posY, 70, (Math.PI/180) * 270, (Math.PI/180) * (270 + vm.radialPercentage) );
            context.stroke();
            if( vm.radialPercentage >= 360 ) clearInterval(arcInterval);
            }, interval);
        
        },
    }
}
</script>
<style scoped>
    #timerCanvas {
        height: auto;
        width: 260px;
    }
    .margin-clock {
        margin-top: 42%;
    }
</style>

